class pgweb.TableFilterBehaviour
	
	_table = null
	_prefix = null

	_keyupCallBack = -> {}
	_switchOnFilterCallBack = -> {}
	_switchOffFilterCallBack = -> {}
	
	constructor: (table, prefix) ->
		_table = table
		_prefix = prefix
		
		$('body').off 'click', '.table-header-filter, .table-header-filter *'
		$('body').on 'click', '.table-header-filter, .table-header-filter *', (event) ->
			headerFilter = $(@).closest '.table-header-filter'
			if headerFilter.context.className != 'table-header-filter' then return
			if $(event.target).context.localName == 'input' then return
			clickedElem = headerFilter
			$('.table-header-filter').each ->
				if $(@).attr('id') == clickedElem.attr 'id'
					$(@).find('.table-header-filter-input').toggle()
				else $(@).find('.table-header-filter-input').hide()
			if headerFilter.find('.table-header-filter-input:visible').length > 0
				textToInput headerFilter
				focusFilterInput headerFilter
			else
				value = inputValue headerFilter
				inputToText headerFilter

		$('body').off 'keyup', '.table-header-filter-input input'
		$('body').on 'keyup', '.table-header-filter-input input', (event) ->
			tableHeaderFilter = $(@).closest '.table-header-filter'
			if event.keyCode == 13
				leaveFilterInput tableHeaderFilter
			else
				inputToText tableHeaderFilter
			_table.runFilter()
			_keyupCallBack()

		$('body').off 'blur', '.table-header-filter-input input'
		$('body').on 'blur', '.table-header-filter-input input', (event) ->
			tableHeaderFilter = $(@).closest '.table-header-filter'
			leaveFilterInput tableHeaderFilter
		
		pgweb.HelpDialog.register('filter-help', 'filter-help-button');
		
		$('body').off 'change', '#filter-onoff'
		$('body').on 'change', '#filter-onoff', (event) ->
			filterOn = $(@).val() == 'on'
			if filterOn
				switchOnFilter()
				$('#filter-help-button').show 'fast'
			else
				switchOffFilter()
				$('#filter-help-button').hide 'fast'
				$('#filter-help').hide 'fast'

	setKeyupCallBack: (cb) -> _keyupCallBack = cb
	
	setSwitchOnFilterCallBack: (cb) -> _switchOnFilterCallBack = cb
	
	setSwitchOffFilterCallBack: (cb) -> _switchOffFilterCallBack = cb

	focusFilterInput = (filter) ->
		filter.find('.table-header-filter-input input').focus()

	leaveFilterInput = (filter) ->
		inputToText filter
		filter.find('.table-header-filter-input').hide()

	textToInput = (filter) ->
		value = (filterValue filter).replace('&lt;', '<').replace('&gt;', '>')
		filter.find('.table-header-filter-input input').val value
	
	inputToText = (filter) ->
		value = inputValue filter
		filter.find('.table-header-filter-value').html value.replace('<', '&lt;').replace('>', '&gt;')
	
	inputValue = (filter) ->
		filter.find('.table-header-filter-input input').val()
	
	filterValue = (filter) ->
		filter.find('.table-header-filter-value').html()

	switchOnFilter = ->
		_table.runFilter()
		$('#filter-header').show()
		_switchOnFilterCallBack()

	switchOffFilter = ->
		_table.runFilter()
		$('#filter-header').hide()
		_switchOffFilterCallBack()

	columnFilterIsOn: ->
		$('#filter-onoff').val() == 'on'

	filterColumnsOneRow: (tr) ->
		show = true
		$('.table-header-filter').each ->
			columnName = $(@).attr('id').substr 2
			cellContent = tr.find('.'+_prefix+'-td-'+columnName+' .table-value').html()
			if cellContent
				cellContent = cellContent.trim()
			text = $(@).find('.table-header-filter-value').html()
			if text.length > 0
				if text == '=.'
					if cellContent != '-' and cellContent != ''
						show = false
				else if text == '!=.'
					if not (cellContent != '-' and cellContent != '')
						show = false
				else if text.substr(0, 8) == '&lt;&gt;' or text.substr(0, 2) == '!='
					if text.substr(0, 8) == '&lt;&gt;'
						l = 8
					if text.substr(0, 2) == '!='
						l = 2
					if text.length > l
						val = text.substr(l)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) != parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() != val.toLowerCase())
									show = false
				else if text.substr(0, 5) == '&lt;='
					if text.length > 5
						val = text.substr(5)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) <= parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() <= val.toLowerCase())
									show = false
				else if text.substr(0, 4) == '&lt;'
					if text.length > 4
						val = text.substr(4)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) < parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() < val.toLowerCase())
									show = false
				else if text.substr(0, 5) == '&gt;='
					if text.length > 5
						val = text.substr(5)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) >= parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() >= val.toLowerCase())
									show = false
				else if text.substr(0, 4) == '&gt;'
					if text.length > 4
						val = text.substr(4)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) > parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() > val.toLowerCase())
									show = false
				else if text.substr(0, 1) == '='
					if text.length > 1
						val = text.substr(1)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							if isNumeric(val)
								if not (parseFloat(commaToDot cellContent) == parseFloat(commaToDot val))
									show = false
							else
								if not (cellContent.toLowerCase() == val.toLowerCase())
									show = false
				else if text.substr(0, 1) == '!'
					if text.length > 1
						val = text.substr(1)
						if !cellContent
							show = false
						else if cellContent == '-'
							show = false
						else
							re = new RegExp(val, 'i')
							if re.test(cellContent)
								show = false
				else
					re = new RegExp(text, 'i')
					if !re.test(cellContent)
						show = false
		show

